





























































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import AuthModule from "@/store/modules/Auth";
import AccountModule from "@/store/modules/Account";
import DashboardModule from "@/store/modules/Dashboard";
import AgentBannerModule from "@/store/modules/AgentBanner";
import DownlineChart from "@/components/Chart/Downline.vue";
import BalanceChart from "@/components/Chart/Balance.vue";
import NewDownlineChart from "@/components/Chart/NewDownline.vue";
import moment from "moment";
import ErrorHandleMixin from "@/mixins/ErrorHandle.vue";
import ProfileModule from "@/store/modules/Profile";

@Component({
  components: {
    DownlineChart,
    BalanceChart,
    NewDownlineChart,
  },
})
export default class DashboardView extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  AccountInstance = getModule(AccountModule, this.$store);

  DashboardInstance = getModule(DashboardModule, this.$store);

  AgentBannerInstance = getModule(AgentBannerModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  pageOption = {
    page: 1,
    limit: 1,
  };

  isShowModal = false;

  downlineSeries: any = [];

  balanceSeries: any = [];

  newDownlineSeries: any = [];

  activeUserSeries: any = [];

  depositWithdrawSeries: any = [];

  refillDeductSeries: any = [];

  compDownlineKey = 0;

  compBalanceKey = 0;

  compNewDownlineKey = 0;

  compActiveUserKey = 0;

  compDepositWithdrawKey = 0;

  compRefillDeductKey = 0;

  items = [];

  todayUser = 0;

  weekUser = 0;

  monthUser = 0;

  memberAmount = 0;

  agentAmount = 0;

  todayTurnover = 0;

  todayWL = 0;

  ytdturnover = 0;

  ytdWL = 0;

  @Watch("$i18n.locale")
  onLanguagChange() {
    this.compDownlineKey += 1;
    this.compBalanceKey += 1;
    this.compNewDownlineKey += 1;
    this.compActiveUserKey += 1;
    this.compDepositWithdrawKey += 1;
    this.compRefillDeductKey += 1;
  }

  async created() {
    await this.ProfileInstance.GetBalance();
    this.isShowModal = true;

    const {
      username, source, role, _id,
    } = this.AuthInstance.user;
    const length = moment().daysInMonth();

    await this.AgentBannerInstance.FetchAgentBanner({ isActive: true });
    this.items = this.AgentBannerInstance.list.map((item) => ({ src: item.imagePath, img: true }));
    await this.DashboardInstance.FetchDashboard({
      username,
      source,
      role,
      _id,
    });
    await this.DashboardInstance.FetchDashboardReport();
    this.memberAmount = this.AccountInstance.users.memberAmount;
    this.agentAmount = this.AccountInstance.users.agentAmount;
    this.todayUser = this.DashboardInstance.dashboard.today.totalMemberCount.length
      ? this.DashboardInstance.dashboard.week.totalMemberCount
        .map((item) => item.count)
        .reduce((a, b) => a + b)
      : 0;
    this.weekUser = this.DashboardInstance.dashboard.week.totalMemberCount.length
      ? this.DashboardInstance.dashboard.week.totalMemberCount
        .map((item) => item.count)
        .reduce((a, b) => a + b)
      : 0;
    this.monthUser = this.DashboardInstance.dashboard.month.totalMemberCount.length
      ? this.DashboardInstance.dashboard.month.totalMemberCount
        .map((item) => item.count)
        .reduce((a, b) => a + b)
      : 0;
    const dataWL = Array.from({ length }, () => 0);
    const dataTO = Array.from({ length }, () => 0);
    const dataCom = Array.from({ length }, () => 0);
    const dataMB = Array.from({ length }, () => 0);
    const dataAG = Array.from({ length }, () => 0);
    const dataAU = Array.from({ length }, () => 0);
    const dataDPA = Array.from({ length }, () => 0);
    const dataDPM = Array.from({ length }, () => 0);
    const dataWDA = Array.from({ length }, () => 0);
    const dataWDM = Array.from({ length }, () => 0);
    const dataRFA = Array.from({ length }, () => 0);
    const dataRFM = Array.from({ length }, () => 0);
    const dataDDA = Array.from({ length }, () => 0);
    const dataDDM = Array.from({ length }, () => 0);
    this.DashboardInstance.dashboard.month.data.forEach((element) => {
      dataDPA[+String(element._id).slice(-2) - 1] = element.deposit_agent;
      dataDPM[+String(element._id).slice(-2) - 1] = element.deposit_member;
      dataWDA[+String(element._id).slice(-2) - 1] = element.withdraw_agent;
      dataWDM[+String(element._id).slice(-2) - 1] = element.withdraw_member;
      dataRFA[+String(element._id).slice(-2) - 1] = element.refill_agent;
      dataRFM[+String(element._id).slice(-2) - 1] = element.refill_member;
      dataDDA[+String(element._id).slice(-2) - 1] = element.deduct_agent;
      dataDDM[+String(element._id).slice(-2) - 1] = element.deduct_member;
    });
    this.DashboardInstance.dashboard.month.totalMemberCount.forEach((element) => {
      dataMB[+String(element._id).slice(-2) - 1] = element.count;
    });
    this.DashboardInstance.dashboard.month.totalAgentCount.forEach((element) => {
      dataAG[+String(element._id).slice(-2) - 1] = element.count;
    });
    this.DashboardInstance.dashboardReport.forEach((element) => {
      dataWL[+String(element._id).slice(-2) - 1] = element.winlose;
      dataTO[+String(element._id).slice(-2) - 1] = element.turnover;
      dataCom[+String(element._id).slice(-2) - 1] = element.marketing;
      dataAU[+String(element._id).slice(-2) - 1] = element.activeUser;
    });

    if (this.DashboardInstance.dashboardReport.length > 2) {
      this.todayTurnover = this.DashboardInstance.dashboardReport[
        this.DashboardInstance.dashboardReport.length - 1
      ].turnover;

      this.todayWL = this.DashboardInstance.dashboardReport[
        this.DashboardInstance.dashboardReport.length - 1
      ].winlose;

      this.ytdturnover = this.DashboardInstance.dashboardReport[
        this.DashboardInstance.dashboardReport.length - 2
      ].turnover;

      this.ytdWL = this.DashboardInstance.dashboardReport[
        this.DashboardInstance.dashboardReport.length - 2
      ].winlose;
    } else {
      this.todayTurnover = 0;
      this.todayWL = 0;
      this.ytdturnover = 0;
      this.ytdWL = 0;
    }

    this.balanceSeries = [
      {
        name: "Marketing",
        data: dataCom,
      },
      {
        name: "Turnover",
        data: dataTO,
      },
      {
        name: "Winlose",
        data: dataWL,
      },
    ];
    this.newDownlineSeries = [
      {
        name: "Member",
        data: dataMB,
      },
      {
        name: "Agent",
        data: dataAG,
      },
    ];
    this.activeUserSeries = [
      {
        name: "Active user",
        data: dataAU,
      },
    ];
    this.depositWithdrawSeries = [
      {
        name: "Deposit member",
        data: dataDPM,
      },
      {
        name: "Deposit agent",
        data: dataDPA,
      },
      {
        name: "Withdraw member",
        data: dataWDM,
      },
      {
        name: "Withdraw agent",
        data: dataWDA,
      },
    ];
    this.refillDeductSeries = [
      {
        name: "Refill member",
        data: dataRFM,
      },
      {
        name: "Refill agent",
        data: dataRFA,
      },
      {
        name: "Deduct member",
        data: dataDDM,
      },
      {
        name: "Deduct agent",
        data: dataDDA,
      },
    ];
    this.downlineSeries = [
      {
        name: "Downline",
        data: [
          {
            name: "Member",
            y: this.AccountInstance.users.memberAmount,
          },
          {
            name: "Agent",
            y: this.AccountInstance.users.agentAmount,
          },
        ],
      },
    ];
    this.compDownlineKey += 1;
    this.compBalanceKey += 1;
    this.compNewDownlineKey += 1;
    this.compActiveUserKey += 1;
    this.compDepositWithdrawKey += 1;
    this.compRefillDeductKey += 1;
  }

  closeAlert() {
    this.isShowModal = false;
  }
}
